import React from "react";
import NoSurveyImg from "../assets/images/noSurvey.svg";

const NoSurvey = ({ type, text }) => {
  return (
    <div className="emptyState">
      <div className="no-template">
        <img src={NoSurveyImg} alt="" />
        <h4>{type}</h4>
        <p>{text}.</p>
      </div>
    </div>
  );
};

export default NoSurvey;
